import {createSlice} from "@reduxjs/toolkit";
import {v4 as uuidv4} from "uuid";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        token: localStorage.getItem('kaan-token'),
        user: null,
        guestId: uuidv4(),
        isAuth: !!localStorage.getItem('kaan-token'),
    },
    reducers: {
        login: (state, action) => {
            state.token = action.payload.token;
            state.isAuth = action.payload.isAuth
        },
        logout: (state) => {
            state.token = undefined;
            state.isAuth = false;
        }
    },
});

export default authSlice.reducer;
export const AuthActions = {...authSlice.actions}
